import { render, staticRenderFns } from "./CreditExtension.vue?vue&type=template&id=3e80e37f&scoped=true&"
import script from "./CreditExtension.vue?vue&type=script&lang=js&"
export * from "./CreditExtension.vue?vue&type=script&lang=js&"
import style0 from "./CreditExtension.vue?vue&type=style&index=0&id=3e80e37f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e80e37f",
  null
  
)

export default component.exports